exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom-carousel .VueCarousel-wrapper,\n.media-zoom-carousel .VueCarousel-inner,\n.media-zoom-carousel .VueCarousel-slide {\n  height: 100%;\n}\n", ""]);

// exports
